import { useState } from "react";
import "./RatingInput.css";

const RatingInput = ({ value, onChange, disabled = false }) => {
  const [hovered, setHovered] = useState(0);
  const display = hovered || value;

  return (
    <span
      className="ri-wrap"
      role="radiogroup"
      aria-label="Select a star rating"
      onMouseLeave={() => setHovered(0)}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} star${star !== 1 ? "s" : ""}`}
          className={`ri-star${display >= star ? " ri-on" : ""}`}
          disabled={disabled}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHovered(star)}
          onKeyDown={(e) => {
            if (e.key === "ArrowRight" && value < 5) onChange(value + 1);
            if (e.key === "ArrowLeft"  && value > 1) onChange(value - 1);
          }}
        >
          ★
        </button>
      ))}
    </span>
  );
};

export default RatingInput;
